import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { App } from './App';
import { DashboardLayout } from './components/DashboardLayout';
import { LawVoAICopilot } from './pages/LawVoAICopilot';
import { AllTemplates } from './pages/AllTemplates';
import { MyDocuments } from './pages/MyDocuments';
import { Wills } from './pages/Wills';
import { LegalHelp } from './pages/LegalHelp';
import { MyAccount } from './pages/MyAccount';
import { LegalHealthCheck } from './pages/LegalHealthCheck';
import { Claims } from './pages/Claims';
import { NewUserDashboard } from './pages/NewUserDashboard';
import { LegalOS } from './pages/LegalOS';
import { Indexv2 } from './pages/Indexv2';
import { Auth } from './pages/Auth';
import { LawyerAuth } from './pages/LawyerAuth';
import { SharedReportViewer } from './pages/SharedReportViewer';
import { PartnerWorkflow } from './pages/PartnerWorkflow';
import { LegalSupportTriage } from './pages/LegalSupportTriage';
export function AppRouter() {
  return <BrowserRouter data-id="element-9">
      <Routes data-id="element-10">
        {/* Auth Pages */}
        <Route path="/login" element={<Auth data-id="element-12" />} data-id="element-11" />
        <Route path="/signup" element={<Auth data-id="element-14" />} data-id="element-13" />
        <Route path="/lawyer-login" element={<LawyerAuth data-id="element-16" />} data-id="element-15" />
        <Route path="/lawyer-signup" element={<LawyerAuth data-id="element-18" />} data-id="element-17" />

        {/* Pages with Sidebar Layout */}
        <Route element={<DashboardLayout data-id="element-20" />} data-id="element-19">
          <Route path="/" element={<Navigate to="/legal-support-triage" replace data-id="element-22" />} data-id="element-21" />
          <Route path="/dashboard" element={<App data-id="element-24" />} data-id="element-23" />
          <Route path="/all-templates" element={<AllTemplates data-id="element-26" />} data-id="element-25" />
          <Route path="/my-documents" element={<MyDocuments data-id="element-28" />} data-id="element-27" />
          <Route path="/wills" element={<Wills data-id="element-30" />} data-id="element-29" />
          <Route path="/legal-help" element={<LegalHelp data-id="element-32" />} data-id="element-31" />
          <Route path="/my-account" element={<MyAccount data-id="element-34" />} data-id="element-33" />
          <Route path="/legal-health-check" element={<LegalHealthCheck data-id="element-36" />} data-id="element-35" />
          <Route path="/claims" element={<Claims data-id="element-38" />} data-id="element-37" />
          <Route path="/partner-workflow" element={<PartnerWorkflow data-id="element-40" />} data-id="element-39" />
          <Route path="/legal-support-triage" element={<LegalSupportTriage data-id="element-42" />} data-id="element-41" />
        </Route>

        {/* Standalone Pages */}
        <Route path="/ai-copilot" element={<LawVoAICopilot data-id="element-44" />} data-id="element-43" />
        <Route path="/shared-report/:id" element={<SharedReportViewer data-id="element-46" />} data-id="element-45" />

        {/* Existing Routes */}
        <Route path="/newuser" element={<NewUserDashboard data-id="element-48" />} data-id="element-47" />
        <Route path="/legalos" element={<LegalOS data-id="element-50" />} data-id="element-49" />
        <Route path="/LegalOS" element={<LegalOS data-id="element-52" />} data-id="element-51" />
        <Route path="/indexv2" element={<Indexv2 data-id="element-54" />} data-id="element-53" />
      </Routes>
    </BrowserRouter>;
}